import { render, staticRenderFns } from "./BindTitle.vue?vue&type=template&id=68b0f214&"
import script from "./BindTitle.vue?vue&type=script&lang=ts&"
export * from "./BindTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports